














































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import firebase from 'firebase';
import { GrowthCycle } from '../models/growth-cycle';
import { GrowBed, Farm } from '../models/farm';
import moment from 'moment';
import { Moment } from 'moment';

import * as d3 from 'd3';

@Component
export default class Planning extends Vue {
    @State('farms') private farmsState: any;
    @State('currentFarm') private currentFarmState: any;

    private RAFT_SIZE = 8;
    private RAFT_WIDTH = 2;
    private RAFT_HEIGHT = 4;

    private growthCyclesRef = firebase.firestore().collection('growthCycles');
    private farmsRef = firebase.firestore().collection('farms');

    private currentGrowthCycles: GrowthCycle[] = [];
    private growBeds: GrowBed[] = [];
    private loadingData = false;

    private totalRafts: number = 0;
    private usedRafts: number = 0;
    private raftsRemaining: number = 0;

    private planningDate: Moment = moment();

    private calculateUsedRafts(): void {

        this.usedRafts = 0;

        this.currentGrowthCycles.forEach((growthCycle: GrowthCycle) => {

            // If we don't have an end date, just always keep it in range
            const estimatedEndDate =
                growthCycle.estimatedHarvestDate ?
                moment(growthCycle.estimatedHarvestDate.toDate()) :
                this.planningDate.add(1 , 'days');

            if (estimatedEndDate.isSameOrAfter(this.planningDate) && growthCycle.finishedSpacingRafts) {
                this.usedRafts += growthCycle.finishedSpacingRafts;

                this.usedRafts += (growthCycle.finishedSpacingCellsRemaining) ? 1 : 0;
            } else if (estimatedEndDate.isSameOrAfter(this.planningDate) && growthCycle.highDensityRafts) {
                this.usedRafts += growthCycle.highDensityRafts;

                this.usedRafts += (growthCycle.highDensityCellsRemaining) ? 1 : 0;
            }
        });
    }

    private setupBedsVisual(): void {
        const xPos = 1;
        const yPos = 1;
        const cellWidth = 15;
        const cellHeight = 15;

        const bedGrid: Array<{width: number, height: number, id: number}> = [];
        const growBedSqFt: number[] = [];
        let totalSqFt = 0;

        this.growBeds.map((growBed: GrowBed, index: number) => {
            growBedSqFt.push(parseInt(growBed.width.toString(), 10) * parseInt(growBed.length.toString(), 10));

            const w = parseInt(growBed.width.toString(), 10) / this.RAFT_WIDTH;
            const h = parseInt(growBed.length.toString(), 10) / this.RAFT_HEIGHT;

            bedGrid.push({width: w, height: h, id: index + 1});
        });

        let tempRafts = this.usedRafts;

        // Reset the visual
        d3.select('#growBeds').html('');

        // Now setup the grids
        bedGrid.forEach((grid) => {
            const data = new Array();

            const d3Grid = d3.select('#growBeds')
                .append('svg')
                .attr('width', grid.width * cellWidth)
                .attr('height', grid.height * cellHeight)
                .attr('stroke', '#242424')
                .attr('class', 'Planning-bedGrid');

            for (let i = 0; i < grid.width * grid.height; i++) {

                const cellColor = (tempRafts) > 0 ? '#228B22' : '#FFFFFF';

                data.push({
                    id: i,
                    color: cellColor,
                });

                tempRafts -= 1;
            }

            const cell = d3Grid.selectAll('.cell')
                .data(data);

            cell.enter().append('rect')
                .attr('class', 'cell')
                .attr('x', (x) => (x.id % grid.width) * cellWidth)
                .attr('y', (x) => Math.floor(x.id / grid.width) * cellHeight)
                .attr('width', cellWidth)
                .attr('height', cellHeight)
                .attr('stroke', '#242424')
                .attr('fill', (c) => c.color);

        });

        growBedSqFt.forEach((val) => totalSqFt += val);

        this.totalRafts = Math.floor(totalSqFt / this.RAFT_SIZE);

        this.raftsRemaining = this.totalRafts - this.usedRafts;

        this.loadingData = false;
    }

    private created(): void {
        this.loadingData = true;

        this.$store.watch((state) => {
            return this.$store.state.currentFarm;
        }, (newVal: Farm) => {
            if (newVal.id) {
                const farmRef = this.farmsRef.doc(newVal.id);
                this.growthCyclesRef.where('isCompleted', '==', false).where('farmId', '==', farmRef)
                .get().then((growthCyclesSnapshot) => {
                    this.currentGrowthCycles = [];
                    growthCyclesSnapshot.forEach((growthCyclesData) => {
                        const result = growthCyclesData.data() as GrowthCycle;
                        this.currentGrowthCycles.push({ ...result });
                    });

                    this.farmsRef.doc(newVal.id).get().then((farmData) => {
                        const result = farmData.data()!!.growBeds as GrowBed[];
                        this.growBeds = result;

                        this.calculateUsedRafts();
                        this.setupBedsVisual();
                    });
                });
            }
        }, {
            immediate: true,
        });

        this.loadingData = false;
    }

    private prevDate(): void {
        this.loadingData = true;

        const newDate = this.planningDate.subtract(1, 'days');
        this.planningDate = newDate;

        this.calculateUsedRafts();

        this.loadingData = false;
    }

    private nextDate(): void {
        this.loadingData = true;

        const newDate = this.planningDate.add(1, 'days');
        this.planningDate = newDate;

        this.calculateUsedRafts();

        this.loadingData = false;
    }
}
